/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */

import { useHistory, Link } from "react-router-dom";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";

import { IVeiculo } from "../../../interface/detran";
import { LabelInfo } from "../../../components";

interface Veiculo {
  dados: IVeiculo;
}

const styleInputs = {
  display: "flex",
  flexDirection: "row",
  gap: 1,
};

export const FichaVeiculo: React.FC = () => {
  const history = useHistory();

  const dadosVeiculo = (history?.location?.state as Veiculo).dados;

  const imprimir = () => {
    window.print();
  };

  const voltar = () => {
    history.goBack();
  };

  const theme = MUI.useTheme();

  const boletim =
    dadosVeiculo.situacao_DRFV === "Alertado" &&
    dadosVeiculo.numero_bo !== "" &&
    dadosVeiculo.numero_bo !== null;

  return (
    <MUI.Stack
      pt={[2, 0]}
      flexDirection="row"
      width="100%"
      height="80vh"
      overflow="auto"
      sx={{
        "@media print": {
          overflow: "hidden !important",
          height: "100%",
          pageBreakInside: "avoid",
        },
      }}
    >
      <MUI.Stack p={2} flex={1}>
        <MUI.Stack
          mb={1}
          gap={[1, 0]}
          width="100%"
          flexDirection={["column", "row"]}
          justifyContent="space-between"
          sx={{
            displayPrint: "none",
          }}
        >
          <MUI.Button
            variant="contained"
            startIcon={<Icon.KeyboardReturn />}
            onClick={voltar}
          >
            Voltar para pesquisa
          </MUI.Button>
          <MUI.Button variant="contained" onClick={imprimir}>
            Imprimir
          </MUI.Button>
        </MUI.Stack>

        <MUI.Stack pb={2}>
          <MUI.Typography bgcolor={theme.palette.secondary.light} variant="h6">
            Informações do Veículo
          </MUI.Typography>
          <MUI.Divider
            sx={{
              borderWidth: 1.5,
              backgroundColor: `${theme.palette.secondary.contrastText}`,
            }}
          />

          <MUI.Grid container spacing={1} py={1}>
            {/* <MUI.Grid xs={12} md={6} sm={6} item sx={styleInputs}>
              <MUI.Typography fontWeight="bold" variant="body1">
                Situaçao DRFV:
              </MUI.Typography>
              <MUI.Typography
                variant="body1"
                sx={{
                  background:
                    dadosVeiculo.situacao_DRFV === 'Alertado'
                      ? '#c53030'
                      : '#37b449',
                  color: '#fff',
                  borderRadius: '5px',
                  padding: '0 0.8rem',
                }}
              >
                {dadosVeiculo.situacao_DRFV}
              </MUI.Typography>
            </MUI.Grid> */}

            {boletim && (
              <MUI.Grid xs={12} md={6} sm={6} item sx={styleInputs}>
                <LabelInfo label="Nº do BO:" info={dadosVeiculo.numero_bo} />
              </MUI.Grid>
            )}

            <MUI.Grid xs={12} md={6} sm={6} item sx={styleInputs}>
              <MUI.Typography fontWeight="bold" variant="body1">
                Situação:
              </MUI.Typography>
              <MUI.Typography
                variant="body1"
                sx={{
                  background: dadosVeiculo.Situacao
                    ? dadosVeiculo.Situacao !== "N"
                      ? "#c53030"
                      : "#37b449"
                    : "#37b449",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "0 0.8rem",
                }}
              >
                {dadosVeiculo.Situacao
                  ? dadosVeiculo.Situacao === "N"
                    ? "Nada Consta"
                    : "Rest p/ roubo/furto"
                  : "Nada Consta"}
              </MUI.Typography>
            </MUI.Grid>

            {dadosVeiculo?.fone_queixoso && (
              <MUI.Grid xs={12} md={6} sm={6} item sx={styleInputs}>
                <LabelInfo
                  label="Telefone:"
                  info={dadosVeiculo?.fone_queixoso || "Não informado"}
                />
              </MUI.Grid>
            )}

            {dadosVeiculo?.end_queixoso && (
              <MUI.Grid xs={12} md={6} sm={6} item sx={styleInputs}>
                <LabelInfo
                  label="Endereço:"
                  info={dadosVeiculo?.end_queixoso || "Não informado"}
                />
              </MUI.Grid>
            )}
          </MUI.Grid>
          <MUI.Divider />
          <MUI.Grid container spacing={1} py={1}>
            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo label="Placa:" info={dadosVeiculo?.Placa} />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Chassi:"
                info={dadosVeiculo?.Chassi || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Renavam:"
                info={dadosVeiculo?.Renavam || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="CRV:"
                info={dadosVeiculo?.CRV || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Tipo:"
                info={dadosVeiculo?.TipoVeic || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Categoria:"
                info={dadosVeiculo?.Categoria || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Combustível:"
                info={dadosVeiculo?.Combustivel || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Marca / Modelo:"
                info={dadosVeiculo?.Marca || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Cor:"
                info={dadosVeiculo?.Cor || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <MUI.Typography fontWeight="bold" variant="body1">
                Ano de fabricação / Ano modelo:
              </MUI.Typography>
              <MUI.Typography variant="body1">
                {dadosVeiculo?.AnoFabricacao} - {dadosVeiculo?.AnoModelo}
              </MUI.Typography>
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="UF:"
                info={dadosVeiculo?.UFPlaca || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Município:"
                info={dadosVeiculo?.Municipio || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Bairro:"
                info={dadosVeiculo?.Bairro || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Logradouro:"
                info={dadosVeiculo?.Logradouro || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Complemento:"
                info={dadosVeiculo?.Complemento || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="CEP:"
                info={dadosVeiculo?.CEP || "Não informado"}
              />
            </MUI.Grid>
          </MUI.Grid>

          <MUI.Divider />

          <MUI.Grid container spacing={1} py={1}>
            <MUI.Grid xs={12} md={6} sm={6} item sx={styleInputs}>
              <LabelInfo
                label="Nome do proprietário:"
                info={dadosVeiculo?.Nome || "Não informado"}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} md={6} sm={6} item sx={styleInputs}>
              <LabelInfo
                label="CPF do proprietário:"
                info={dadosVeiculo?.CPFCGC || "Não informado"}
              />
            </MUI.Grid>
          </MUI.Grid>

          <MUI.Divider />

          <MUI.Grid container spacing={1} py={1}>
            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Licenciamento: R$"
                info={dadosVeiculo.debitos.valorLicenciamento}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Valor IPVA SEFAZ: R$"
                info={dadosVeiculo.debitos.ipvaSefaz}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label=" Valor IPVA único: R$"
                info={dadosVeiculo.debitos.ipvaUnica}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Valor IPVA parcelas: R$"
                info={dadosVeiculo.debitos.parcelaIpva}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Bombeiro: R$"
                info={dadosVeiculo.debitos.valorBombeiros}
              />
            </MUI.Grid>

            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo
                label="Valor multas: R$"
                info={dadosVeiculo.debitos.valorMulta}
              />
            </MUI.Grid>
          </MUI.Grid>
        </MUI.Stack>
      </MUI.Stack>
    </MUI.Stack>
  );
};
